<template>
  <b-container fluid class="div-background">
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-alert
      :show="messageObject.warning.count"
      variant="danger"
      dismissible
      @dismissed="messageObject.warning.count = 0"
      @dismiss-count-down="warningCountChanged"
      >{{ messageObject.warning.content }}
    </b-alert>
    <b-row align-h="center">
      <b-col md="5" class="setdivheight">
        <h2>密碼變更</h2>
        <b-form-group
          label="新密碼："
          description="英文字母與數字組合，長度8個字元以上不含空白字元"
        >
          <b-form-input
            v-model="passwordobject.first.value"
            aria-describedby="firstpwd-feedback"
            :state="passwordobject.first.state"
            type="password"
            required
          >
          </b-form-input>
          <b-form-invalid-feedback id="firstpwd-feedback">
            {{ passwordobject.first.message }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="確認新密碼：" description="確認密碼">
          <b-form-input
            v-model="passwordobject.second.value"
            aria-describedby="secondpwd-feedback"
            :state="passwordobject.second.state"
            type="password"
            required
          >
          </b-form-input>
          <b-form-invalid-feedback id="secondpwd-feedback">
            {{ passwordobject.second.message }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-button @click="callModal" block size="lg" variant="primary"
          >確定修改</b-button
        >
      </b-col>
    </b-row>
    <b-modal
      id="modal-changepassword"
      ref="changepasswordmodal"
      title="修改密碼"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      確定要修改密碼?
    </b-modal>
  </b-container>
</template>
<script>
export default {
  data() {
    return {
      PassToken: this.$route.query.Token,
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#",
        },
        {
          text: "密碼變更",
          active: true,
        },
      ],
      passwordobject: {
        first: {
          value: null,
          state: null,
          message: "欄位不能為空值",
        },
        second: {
          value: null,
          state: null,
          message: "欄位不能為空值",
        },
      },
      messageObject: {
        warning: {
          show: false,
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      apiUpdatePassword: (data) =>
        this.userRequest.post("API/Default/LastPassReset", data),
    };
  },
  methods: {
    updatePassword(data) {
      this.apiUpdatePassword(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            sessionStorage.removeItem("TokenID");
            sessionStorage.removeItem("username");
            this.$router.push({ path: "login" });
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    callModal() {
      if (
        this.passwordobject.first.value == "" ||
        this.passwordobject.second.value == "" ||
        this.passwordobject.first.value == null ||
        this.passwordobject.second.value == null
      ) {
        this.warningPopUp("密碼欄位不能為空值");
      } else if (
        this.passwordobject.first.value != this.passwordobject.second.value
      ) {
        this.warningPopUp("兩次密碼輸入不相同");
      } else if (
        this.passwordobject.first.state == false ||
        this.passwordobject.second.state == false
      ) {
        this.warningPopUp("密碼資料格式有誤");
      } else {
        this.$refs["changepasswordmodal"].show();
      }
    },
    resetModal() {
      this.$refs["changepasswordmodal"].hide();
    },
    handleOk() {
      let data = {
        PassToken: this.PassToken,
        DecryptionPass: this.passwordobject.first.value,
      };
      this.FunctionToken(this.updatePassword, data);
    },
    warningPopUp(msg) {
      this.messageObject.warning.count = this.messageObject.dismissSecs;
      this.messageObject.warning.content = msg;
    },
    warningCountChanged(count) {
      this.messageObject.warning.count = count;
    },
  },
  watch: {
    "passwordobject.first.value"(val) {
      if (val.length == 0) {
        this.passwordobject.first.message = "欄位不能為空";
        this.passwordobject.first.state = false;
      } else if (val.length < 8) {
        this.passwordobject.first.message = "密碼至少8個字元";
        this.passwordobject.first.state = false;
      } else {
        let numasc = 0;
        let charasc = 0;
        for (let i = 0; i < val.length; i++) {
          let asciiNumber = val.substr(i, 1).charCodeAt();
          if (asciiNumber >= 48 && asciiNumber <= 57) {
            numasc = 1;
          }
          if (
            (asciiNumber >= 65 && asciiNumber <= 90) ||
            (asciiNumber >= 97 && asciiNumber <= 122)
          ) {
            charasc = 1;
          }
        }
        if (numasc == 0) {
          this.passwordobject.first.message = "密碼必須含有數字";
          this.passwordobject.first.state = false;
        } else if (charasc == 0) {
          this.passwordobject.first.message = "密碼必須含有字母";
          this.passwordobject.first.state = false;
        } else {
          this.passwordobject.first.state = true;
        }
      }
    },
    "passwordobject.second.value"(val) {
      if (val.length == 0) {
        this.passwordobject.second.message = "欄位不能為空";
        this.passwordobject.second.state = false;
      } else if (val != this.passwordobject.first.value) {
        this.passwordobject.second.message = "與第一次密碼不對稱";
        this.passwordobject.second.state = false;
      } else {
        this.passwordobject.second.state = true;
      }
    },
  },
};
</script>
